export default class TimeSheetModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
